enum Source {
    'FTP' = 1,
    'Email' = 2,
    'HTTP' = 3,
    'TCP' = 4,
}

export default Source;
